import { DataTable } from "primereact/datatable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { EmptyTenderClientCategory, IModel, ITenderClientCategory } from "./TenderClientCategory";
import React, { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Fetch } from "../../../shared/Fetch";
import { safeFormatDate } from "../../../models/DateFormatMapper";
import { Dialog } from "primereact/dialog";
import { InputSwitch } from "primereact/inputswitch";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Tooltip } from "primereact/tooltip";

interface Iprops {
  setModal: (modal: IModel) => void;
  reload: boolean;
  toast: any;
  permission: IPermissionProps;
}

export const Table = (props: Iprops) => {
  const [tableData, setTableData] = useState<{ tableData: any[]; loading: boolean }>({ tableData: [], loading: false });
  const [descriptionDialog, setDescriptionDialog] = useState<{ visible: boolean; description: string }>({ visible: false, description: "" });
  const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");
  const DateFormat = loginObj.date_Format;

  const loadTenderclient = async () => {
    try {
      setTableData((prev) => ({ ...prev, loading: true }));

      const response = await Fetch("Tender_Client_Category/GetAllTenderClientCategory", "GET", null, null, props.toast);
      if (response?.ok) {
        const data = await response.json();
        setTableData({ tableData: data, loading: false });
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTableData((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    loadTenderclient();
  }, [props.reload]);
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
        </div>
      </React.Fragment>
    );
  };
  const openNew = () => {
    props.setModal({ open: true, singleData: EmptyTenderClientCategory });
  };

  const changeStatus = (rowData: ITenderClientCategory, isActive: boolean) => {
    confirmDialog({
      header: "Confirmation",
      message: isActive ? `Are you sure you want to activate "${rowData.category_Name}" category?` : `Are you sure you want to deactivate "${rowData.category_Name}" category?`,
      icon: "pi pi-exclamation-triangle",

      accept: async () => {
        const response = await Fetch("Tender_Client_Category/ChangeStatus", "PUT", null, `id=${rowData.id}&isActive=${isActive}`, props.toast);

        if (response?.ok) {
          props.toast.current.show({
            severity: "success",
            summary: "Success",
            detail: isActive ? `"${rowData.category_Name}" category has been activated successfully.` : `"${rowData.category_Name}" category has been deactivated successfully.`,
            life: 3000,
          });
          loadTenderclient();
        }
      },
      reject: () => {
        loadTenderclient();
      },
    });
  };

  return (
    <>
      <ConfirmDialog />
      <Toolbar left={leftToolbarTemplate} className="mb-3" />
      <DataTable value={tableData.tableData} loading={tableData.loading} showGridlines stripedRows header="Tender Client Category">
        <Column field="category_Name" header="Category Name" />
        <Column field="added_By" header="Added By" />
        <Column
          header="Description"
          body={(rowData: ITenderClientCategory) =>
            rowData.description ? (
              <>
                <Tooltip target=".view-description" />
                <i className="pi pi-eye view-description cursor-pointer" data-pr-tooltip="View Description" data-pr-position="top" style={{ color: "var(--primary-color)", fontSize: "1.2rem" }} onClick={() => setDescriptionDialog({ visible: true, description: rowData.description || "" })} />
              </>
            ) : (
              "-"
            )
          }
        />
        <Column field="added_On" header="Added On" body={(rowData: any) => safeFormatDate(rowData.added_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column field="updated_By" header="Updated By" />
        <Column field="updated_On" header="Updated On" body={(rowData: any) => safeFormatDate(rowData.updated_On, "dd/MM/yyyy", DateFormat)} style={{ maxWidth: "120px" }} />
        <Column header="Active" body={(rowData: ITenderClientCategory) => <InputSwitch checked={rowData.isActive} onChange={(e) => changeStatus(rowData, e.value)} />} />
        <Column header="Action" body={(rowData: ITenderClientCategory) => <i className="pi pi-pencil text-primary" style={{ cursor: "pointer" }} onClick={() => props.setModal({ open: true, singleData: rowData })} />} />
      </DataTable>
      <Dialog header="Description" visible={descriptionDialog.visible} modal style={{ width: "40vw" }} onHide={() => setDescriptionDialog({ visible: false, description: "" })}>
        <p style={{ whiteSpace: "pre-wrap" }}>{descriptionDialog.description}</p>
      </Dialog>
    </>
  );
};
